import { Component } from '@angular/core';
import { AbstractWidgetComponent } from '@sdbn/common';

@Component({
  selector: 'app-static-content',
  templateUrl: './static-content.component.html',
  styleUrls: ['./static-content.component.scss'],
  standalone: false
})
export class StaticContentComponent extends AbstractWidgetComponent {

  imageSrcFiles: string[] = [];

  titleDictionaryKey: string;

  contentDictionaryKeys: string[];

  onSetElementAndContext() {

    console.log('StaticContentComponent.onSetElementAndContext()', this.widgetReference);

    const propertyImages = this.widgetReference.data['images'];
    const propertyTitle = this.widgetReference.data['title'];
    const propertyDescriptions = this.widgetReference.data['descriptions'];

    if (propertyImages) {
      this.imageSrcFiles = propertyImages.split('|');
    }
    if (propertyTitle) {
      this.titleDictionaryKey = propertyTitle;
    }
    if (propertyDescriptions) {
      this.contentDictionaryKeys = propertyDescriptions.split('|');
    }

  }

}
